export const SAMPLE_PREVIEW_STORAGE_KEY = 'tla_sample_preview_mode';
export const SAMPLE_PREVIEW_EVENT = 'tla-sample-preview-changed';

export function getSamplePreviewEnabled() {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(SAMPLE_PREVIEW_STORAGE_KEY) === 'true';
}

export function setSamplePreviewEnabled(enabled) {
  if (typeof window === 'undefined') return;
  const nextValue = enabled ? 'true' : 'false';
  window.localStorage.setItem(SAMPLE_PREVIEW_STORAGE_KEY, nextValue);
  window.dispatchEvent(
    new CustomEvent(SAMPLE_PREVIEW_EVENT, { detail: { enabled: enabled === true } })
  );
}

export function subscribeToSamplePreviewMode(callback) {
  if (typeof window === 'undefined') return () => {};

  const handleStorage = (event) => {
    if (event.key === SAMPLE_PREVIEW_STORAGE_KEY) {
      callback(event.newValue === 'true');
    }
  };

  const handleCustomEvent = (event) => {
    callback(Boolean(event.detail?.enabled));
  };

  window.addEventListener('storage', handleStorage);
  window.addEventListener(SAMPLE_PREVIEW_EVENT, handleCustomEvent);

  return () => {
    window.removeEventListener('storage', handleStorage);
    window.removeEventListener(SAMPLE_PREVIEW_EVENT, handleCustomEvent);
  };
}
